import { ErrorBoundary, NoAccess } from "@neonumy/ant-design";
import { APP_URLS } from "@neonumy/api-clients";
import PrivateRoute from "config/routes/PrivateRoute";
import { Suspense, lazy } from "react";
import { Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import LoadingPage from "views/Base/LoadingPage";
import Page404 from "views/Base/Page404";

const BookEntry = lazy(() => import("views/Bulk"));
const Home = lazy(() => import("views/Home"));
const PreviewDocument = lazy(() => import("views/PreviewDocument/index"));

const routes = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/"
        element={
          <ErrorBoundary>
            <PrivateRoute />
          </ErrorBoundary>
        }
      >
        <Route index element={<Home />} />
        <Route path="accounting-firm/:accountingFirmId" element={<Home />} />
        <Route path="company/:companyId" element={<Home />} />

        <Route path="bulk/:bulkid" element={<BookEntry />} />
        <Route path="bulk/:bulkid/book-entry/:bookEntryId" element={<BookEntry />} />
        <Route path="bulk/:bulkid/document/:documentId" element={<BookEntry />} />

        <Route path="preview" element={<PreviewDocument />} />
        <Route
          path="*"
          element={
            <Suspense fallback={<LoadingPage />}>
              <Page404 />
            </Suspense>
          }
        />
      </Route>
      <Route path="no-access" element={<NoAccess dashboardUrl={APP_URLS.dashboardUrl} />} />
    </>,
  ),
);

export { routes };
